import { Component, Input, OnInit } from '@angular/core';

import { ValidationError } from '../../models';

@Component({
    standalone: false,
    selector: 'abs-force-validation',
    template: `
        <div
            class="gutter-collapse"
            [class.error]="error?.type !== 'Warning'"
            [class.warning]="error?.type === 'Warning'"
            *ngFor="let error of errors"
        >
            {{ error.messageKey | translate: error }}
        </div>
    `
})
export class ForceValidationComponent {
    @Input()
    errors: ValidationError[];
}
